import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth, API_URL } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import AdminNav from './AdminNav';

const NIVELES_MILITAR = ['SLP2', 'SLP3', 'SLP4', 'ACCESO_SUBOFICIAL', 'ACCESO_OFICIAL', 'CURSO_SUBOFICIAL', 'CURSO_OFICIAL'];
const NIVELES_CIVIL   = ['B1', 'B2', 'C1', 'C2'];
const NIVEL_LABEL = { SLP1:'SLP 1', SLP2:'SLP 2', SLP3:'SLP 3', SLP4:'SLP 4', ACCESO_SUBOFICIAL:'Acceso Suboficial', ACCESO_OFICIAL:'Acceso Oficial', CURSO_SUBOFICIAL:'Curso Suboficial', CURSO_OFICIAL:'Curso Oficial', B1:'B1', B2:'B2', C1:'C1', C2:'C2' };

const formBase = () => ({ nombre: '', tipo: 'civil', nivel: 'B1', dias: 7 });

export default function AdminAccesosTemporales() {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const [esMobile, setEsMobile] = useState(() => window.innerWidth <= 768);
  const [lista, setLista]       = useState([]);
  const [form, setForm]         = useState(formBase());
  const [creando, setCreando]   = useState(false);
  const [error, setError]       = useState('');
  const [copiado, setCopiado]   = useState(null);

  useEffect(() => {
    const check = () => setEsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    if (usuario?.rol !== 'admin') { navigate('/'); return; }
    cargar();
  }, []);

  const cargar = async () => {
    try {
      const r = await axios.get(`${API_URL}/admin/control/accesos-temporales`);
      setLista(r.data);
    } catch {}
  };

  const crear = async (e) => {
    e.preventDefault();
    setError('');
    setCreando(true);
    try {
      await axios.post(`${API_URL}/admin/control/accesos-temporales`, form);
      setForm(formBase());
      cargar();
    } catch (e) {
      setError(e.response?.data?.error || 'Error al crear');
    } finally { setCreando(false); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este código?')) return;
    try { await axios.delete(`${API_URL}/admin/control/accesos-temporales/${id}`); cargar(); }
    catch {}
  };

  const copiar = (codigo) => {
    navigator.clipboard.writeText(codigo);
    setCopiado(codigo);
    setTimeout(() => setCopiado(null), 2000);
  };

  const ahora = new Date();
  const estadoCodigo = (item) => {
    if (item.usado) return { label: 'Usado', color: '#BE84A3', bg: '#FCE7F3' };
    if (new Date(item.fecha_expiracion) < ahora) return { label: 'Expirado', color: '#F87171', bg: 'rgba(248,113,113,0.1)' };
    return { label: 'Activo', color: '#34D399', bg: '#34D39918' };
  };

  const nivelesDelTipo = form.tipo === 'militar' ? NIVELES_MILITAR : NIVELES_CIVIL;
  const inputStyle = { width: '100%', padding: '10px 14px', borderRadius: '10px', background: '#FFF0F5', border: '1px solid #FBCFE8', color: '#581C47', fontSize: '14px' };
  const btnGrad = { background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)', border: 'none', color: '#fff', padding: '10px 22px', borderRadius: '50px', fontSize: '14px', fontWeight: 600, cursor: 'pointer', boxShadow: '0 4px 14px rgba(236,72,153,0.3)' };

  return (
    <div style={{ minHeight: '100vh', background: '#FFF0F5' }}>
      <AdminNav esMobile={esMobile} tipo="subpagina" titulo={esMobile ? 'Accesos Temp.' : 'Accesos Temporales'} />

      <div style={{ maxWidth: '1000px', padding: esMobile ? '16px 12px 80px' : '32px 24px' }} className="fade-in">
        <h1 style={{ color: '#581C47', fontSize: esMobile ? '20px' : '26px', marginBottom: '4px' }}>🔑 Accesos Temporales</h1>
        <p style={{ color: '#BE84A3', fontSize: '13px', marginBottom: '28px' }}>Genera códigos de acceso con fecha de expiración</p>

        {/* Formulario */}
        <form onSubmit={crear} style={{ background: '#FFFFFF', border: '1px solid #FBCFE8', borderRadius: '16px', padding: esMobile ? '18px 16px' : '24px', marginBottom: '28px', boxShadow: '0 4px 20px rgba(236,72,153,0.07)' }}>
          <h3 style={{ color: '#EC4899', fontSize: '15px', marginBottom: '18px' }}>Nuevo código</h3>
          {error && <div style={{ background: 'rgba(236,72,153,0.08)', border: '1px solid rgba(236,72,153,0.25)', borderRadius: '10px', padding: '10px', color: '#DB2777', marginBottom: '14px', fontSize: '13px' }}>{error}</div>}

          <div style={{ display: 'grid', gridTemplateColumns: esMobile ? '1fr' : '1fr 1fr 1fr 80px', gap: '12px', marginBottom: '14px' }}>
            <div>
              <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '5px' }}>Etiqueta (opcional)</label>
              <input style={inputStyle} placeholder="Ej: Prueba gratuita" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} />
            </div>
            <div>
              <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '5px' }}>Sección</label>
              <select style={inputStyle} value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value, nivel: e.target.value === 'militar' ? 'SLP2' : 'B1' })}>
                <option value="civil">🎓 Civil</option>
                <option value="militar">🎖️ Militar</option>
              </select>
            </div>
            <div>
              <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '5px' }}>Nivel</label>
              <select style={inputStyle} value={form.nivel} onChange={e => setForm({ ...form, nivel: e.target.value })}>
                {nivelesDelTipo.map(n => <option key={n} value={n}>{NIVEL_LABEL[n] || n}</option>)}
              </select>
            </div>
            <div>
              <label style={{ color: '#BE84A3', fontSize: '12px', display: 'block', marginBottom: '5px' }}>Días</label>
              <input type="number" min="1" max="365" style={inputStyle} value={form.dias} onChange={e => setForm({ ...form, dias: e.target.value })} />
            </div>
          </div>

          <button type="submit" disabled={creando} style={{ ...btnGrad, opacity: creando ? 0.6 : 1 }}>
            {creando ? 'Generando...' : '+ Generar código'}
          </button>
        </form>

        {/* Lista */}
        {lista.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '48px', color: '#BE84A3', background: '#FFFFFF', borderRadius: '14px', border: '1px solid #FBCFE8' }}>
            No hay códigos generados aún
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {lista.map(item => {
              const est = estadoCodigo(item);
              const expirado = new Date(item.fecha_expiracion) < ahora;
              return (
                <div key={item.id} style={{ background: '#FFFFFF', border: '1px solid #FBCFE8', borderRadius: '14px', padding: esMobile ? '14px 16px' : '16px 20px', boxShadow: '0 2px 10px rgba(236,72,153,0.05)', display: 'flex', alignItems: 'center', gap: '14px', flexWrap: esMobile ? 'wrap' : undefined, opacity: expirado || item.usado ? 0.65 : 1 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px', flexWrap: 'wrap' }}>
                      <code style={{ background: '#FFF0F5', border: '1px solid #FBCFE8', color: '#EC4899', padding: '4px 12px', borderRadius: '8px', fontSize: '16px', fontWeight: 700, letterSpacing: '2px' }}>
                        {item.codigo}
                      </code>
                      <span style={{ background: est.bg, color: est.color, borderRadius: '6px', padding: '2px 10px', fontSize: '11px', fontWeight: 700 }}>{est.label}</span>
                    </div>
                    <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                      <span style={{ color: '#BE84A3', fontSize: '12px' }}>
                        {item.tipo === 'militar' ? '🎖️' : '🎓'} {item.tipo} · {NIVEL_LABEL[item.nivel] || item.nivel}
                      </span>
                      <span style={{ color: '#BE84A3', fontSize: '12px' }}>⏱ {item.dias} días</span>
                      <span style={{ color: '#BE84A3', fontSize: '12px' }}>
                        Expira: {new Date(item.fecha_expiracion).toLocaleDateString('es-ES')}
                      </span>
                      {item.nombre && <span style={{ color: '#BE84A3', fontSize: '12px' }}>📌 {item.nombre}</span>}
                      {item.usado && item.usado_por_nombre && <span style={{ color: '#BE84A3', fontSize: '12px' }}>👤 {item.usado_por_nombre}</span>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
                    {!item.usado && !expirado && (
                      <button
                        onClick={() => copiar(item.codigo)}
                        style={{ background: copiado === item.codigo ? '#34D39918' : '#FCE7F3', border: `1px solid ${copiado === item.codigo ? '#34D39944' : '#FBCFE8'}`, color: copiado === item.codigo ? '#34D399' : '#EC4899', padding: '6px 14px', borderRadius: '8px', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}
                      >
                        {copiado === item.codigo ? '✓ Copiado' : '📋 Copiar'}
                      </button>
                    )}
                    <button onClick={() => eliminar(item.id)} style={{ background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.25)', color: '#F87171', padding: '6px 10px', borderRadius: '8px', fontSize: '12px', cursor: 'pointer' }}>
                      🗑
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
